<div>
  <div class="col-lg-12 pb-2">
    @if(!routerObject.url.includes("summary") && (userRole === LoggedInUserRole.Internal || userRole === LoggedInUserRole.Admin) && (actionType === actionTypeEnum.Review || actionType === actionTypeEnum.InExecutiveReview) && (selectedYear && selectedYear >= getCurrentYear()) && archiveStatus !== ArchivedStatus.Accepted) {
    <div>
      <p-card>
        <div class="row mb-3 mt-3">
          <div class="col-lg-6">
            <h3>Internal Notes</h3>
            <p-editor [style]="{ height: '250px' }" (onTextChange)="onChangeInternalNotes($event)"
              [(ngModel)]="internalNotes"></p-editor>

          </div>
          <div class="col-lg-6">
            <h3>Vendor Notes</h3>
            <p-editor [style]="{ height: '250px' }" (onTextChange)="onChangeVendorNotes($event)"
              [(ngModel)]="vendorNotes" ></p-editor>
          </div>
          <p-button label="Save" class="mt-4 d-flex justify-content-end" severity="secondary" (click)="onSaveNotes()">
          </p-button>
        </div>
      </p-card>
    </div>
    }
    <div class="col-lg-12 mt-4 summery-btn-btm">
      <div class="row d-flex justify-content-between">
        <!--@if(!routerObject.url.includes("summary")) {-->
        <div class="col-lg-6 col-12 gap-3 d-flex mb-2">
          <!-- <p-button label="Print Vendor Application" severity="secondary" [outlined]="true"></p-button>
          <p-button label="Download All Documents" severity="secondary" [outlined]="true"></p-button> -->
        </div>
        <!--}-->
        @if(routerObject.url.includes("summary") ) {
        @if(userRole === LoggedInUserRole.Internal || userRole === LoggedInUserRole.Admin) {
        <div class="col-lg-6 gap-3 d-flex justify-content-end mb-2">
          <p-button label="Back" class="buttonbg-white" severity="secondary" (click)="onClickBackButton()"
            [outlined]="true"></p-button>
          <p-button [disabled]="actionType === actionTypeEnum.ApprovalInProgress || (selectedYear && selectedYear < getCurrentYear())" (click)="showDialog()"
            label="Send Feedback" severity="secondary"></p-button>
          <p-button [disabled]="actionType === actionTypeEnum.ApprovalInProgress || (selectedYear && selectedYear < getCurrentYear())" label="Approve" severity="secondary"
            (click)="onApprove()" class="successful-btn"></p-button>
          <p-button [disabled]="actionType === actionTypeEnum.ApprovalInProgress || (selectedYear && selectedYear < getCurrentYear())" label="Reject" severity="secondary"
            (click)="rejectPopup()"></p-button>
        </div>
        } @else {
        <div class="col-lg-6 gap-3 d-flex justify-content-end mb-2">
          <p-button label="Back" class="buttonbg-white" severity="secondary" (click)="onClickBackButton()"
            [outlined]="true">
          </p-button>
          @if((actionType === actionTypeEnum.Review || actionType === actionTypeEnum.InExecutiveReview || actionType === actionTypeEnum.ApprovalInProgress) || (selectedYear && selectedYear < getCurrentYear()) || getRenewalStatus()) {
          <p-button
            [disabled]="(actionType === actionTypeEnum.Review || actionType === actionTypeEnum.InExecutiveReview || actionType === actionTypeEnum.ApprovalInProgress) || (selectedYear && selectedYear < getCurrentYear()) || getRenewalStatus()"
            label="Submit" severity="success">
          </p-button>
          } @else {
          <p-button label="Submit" severity="success" (click)="confirmSubmitForReview()">
          </p-button>
          }

        </div>
        }
        }

        <div class="col-sm-auto col-12 gap-3 d-flex mb-2">
          <!--@if(!routerObject.url.includes("dashboard") && !routerObject.url.includes("vendor-information")) {
          <p-button label="Proceed to Review" class="buttonbg-white" severity="secondary" (click)="onClickBackButton()" [outlined]="true">
          </p-button>
          }-->
            @if((routerObject.url.includes("vendor-information") && (userRole === LoggedInUserRole.Internal || userRole === LoggedInUserRole.Admin)) && pendingEnvelopeId && (!selectedYear || selectedYear >= getCurrentYear())) {
              <p-button label="Send Pending Envelope To Reviewer"
                  class="btn-primary"
                  severity="info"
                  (click)="onSendPendingEnvelopeToReviewer()"
                  [loading]="sendPendingEnvelopeInProgress">
              </p-button>
            }
          @if((userRole === LoggedInUserRole.Internal || userRole === LoggedInUserRole.Admin) && shouldInternalShowFillAndSignButton() && (selectedYear && selectedYear > 2025)) {
          <p-button label="Send for Internal Review" severity="info" (click)="onFillAndSignInternalDocuments()" [disabled]="!areAllMandatoryDocumentsUploaded() || fillAndSignInProgress" [loading]="fillAndSignInternalInProgress">
          </p-button>
          }
          @if(!routerObject.url.includes("summary") && (!routerObject.url.includes("vendor-information") ||
          userRole === LoggedInUserRole.Internal || userRole === LoggedInUserRole.Admin) && ((actionType === actionTypeEnum.Review || actionType ===
          actionTypeEnum.ApprovalInProgress || actionType === actionTypeEnum.InExecutiveReview) && (selectedYear && selectedYear >= getCurrentYear()))) {
            <p-button label="Proceed to Review" class="successful-btn" severity="secondary" (click)="onClickNextButton()">
            </p-button>
          }
          @if(routerObject.url.includes("vendor-information") && (userRole === LoggedInUserRole.Vendor || userRole ===
          LoggedInUserRole.SubVendor) && (selectedYear && selectedYear >= getCurrentYear())) {
            @if(shouldShowFillAndSignButton() && (selectedYear && selectedYear > 2025)) {
            <p-button label="Fill and Sign the Documents" severity="info" (click)="onFillAndSignDocuments()" [disabled]="!areAllMandatoryDocumentsUploaded() || fillAndSignInProgress" [loading]="fillAndSignInProgress">
            </p-button>
            } @else {
            <p-button label="Proceed to Review" class="successful-btn" (click)="onSaveAndContinue()" [disabled]="(actionType === actionTypeEnum.Review || actionType === actionTypeEnum.InExecutiveReview) || getRenewalStatus() || !certificationSignatureChecked" severity="secondary">
            </p-button>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Feedback For Vendor" [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }"
  [draggable]="false" [resizable]="false" class="summery-popup-feedback">

  <p class="mt-4">These following feedbacks will be send to corresponding vendor</p>
  @for(feedbackObject1 of feedbackObject; track feedbackObject1.feedbackType) {
  @if(feedbackObject1.selfNotes) {
  <div class="col-lg-12 border p-3 mb-4 sum-list">
    <h4>{{feedbackObject1.feedbackType}}</h4>
    <p class="mb-0" [innerHTML]="feedbackObject1.selfNotes"></p>
    <!-- <p class="p-0 m-0"><b>Sage Number, Middle Name, Phone Number, Fax Number, Dunn & Bradstreet</b></p> -->
  </div>
  }
  }

  <div class="col-auto d-flex gap-4 mb-4 justify-content-end">
    <p-button label="Back" [raised]="true" severity="secondary" (click)="onClickBack()"></p-button>
    <p-button label="Send Feedback" [raised]="true" severity="secondary" (click)="onClickSendFeedback()"></p-button>
  </div>
</p-dialog>

@if(inprogress) {
<div
  class="col-lg-12 position-fixed start-0 top-0 d-flex justify-content-center align-items-center color-box spinner-contr">
  <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4"></p-progressSpinner>
</div>
}
<p-confirmDialog></p-confirmDialog>
<div class="email-temp-popup">
  <p-dialog header="Email Template" [(visible)]="showEmailTemplate" [style]="{width: '70vw', height: '70vw'}"
    class="activity-popup" [modal]="true">
    <div class="custom-container">
      <div class="row mb-3 mt-5">
        <div class="col-lg-12 pb-2 d-flex justify-content-between">
          <div class="col-auto d-flex gap-4">
          </div>
        </div>
        <div [formGroup]="emailTemplateForm" class="col-lg-12 m-auto">
          <p-card>
            <div class="col-lg-12">
              <div class="row">

                <div class="col-lg-12">
                  <span class="p-float-label">
                    <input pInputText id="Subject" class="w-100" [formControlName]="EmailTemplateEnum.EmailSubject"
                      type="text" name="emailSubject" />
                    <label for="username">Subject</label>
                  </span>
                </div>
              </div>
            </div>
          </p-card>
          <div class="col-lg-12 mt-5">
            <h4>Template</h4>
          </div>
          <p-card>
            <div class="col-lg-12">
              <div class="row">
                <h4>Email Text</h4>
                <div class="col-lg-12">
                  <p-editor [style]="{ height: '150px' }" [formControlName]="EmailTemplateEnum.EmailBody">
                  </p-editor>
                </div>
              </div>
            </div>

          </p-card>
        </div>
        <p-button class="mt-3 mb-3" label="Send Email" severity="secondary" (click)="onReject()">
        </p-button>
      </div>
    </div>
    @if(inprogress) {
    <div
      class="col-lg-12 position-fixed top-0 start-0 d-flex justify-content-center align-items-center color-box spinner-contr">
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4"></p-progressSpinner>
    </div>
    }
  </p-dialog>
</div>
<p-dialog (onHide)="backTo()" header="" [(visible)]="toggleApprovalDialog"
          [style]="{width: '40vw', height: '45vh'}" [modal]="true">
  <div class="signup-check-icon bg-white p-5 rounded border text-center">
    @if(isReviewerSignaturesRequired) {
      <i class="pi pi-inbox mb-3"></i>
      <h3 class="p-0">Email has been sent to the reviewer for document signatures. The approval process will continue once all signatures are collected.</h3>
    } @else {
      <i class="pi pi-check-circle mb-3"></i>
      <h3 class="p-0">We are working on your application of approval process you will be notified shortly after the process is completed.</h3>
    }
    <a class="bck-dashboard p-3 rounded" routerLink="/dashboard">
      Go Back to Dashboad
    </a>
  </div>
</p-dialog>

<!-- Main Contact Dialog -->
<p-dialog header="Main Contact Email" [(visible)]="showMainContactDialog" [modal]="true" [style]="{ width: '40vw' }"
  [draggable]="false" [resizable]="false" [closable]="false" class="main-contact-popup">
  <div class="col-lg-12">
    <p class="mb-4">Please provide the main contact email address to proceed with Fill and Sign.</p>
    <div class="row">
      <div class="col-lg-12 mb-4">
        <span class="p-float-label">
          <input 
            pInputText 
            id="mainContactEmail" 
            class="w-100" 
            [(ngModel)]="mainContactEmail" 
            type="email" 
            name="mainContactEmail"
            [class.ng-invalid]="mainContactEmailInvalid"
            [class.ng-dirty]="mainContactEmailInvalid"
            (input)="mainContactEmailInvalid = false" />
          <label for="mainContactEmail">Email *</label>
        </span>
        @if(mainContactEmailInvalid) {
          <small class="p-error">Please enter a valid email address</small>
        }
      </div>
    </div>
  </div>

  <div class="col-auto d-flex gap-3 justify-content-end mt-3">
    <p-button label="Cancel" [raised]="true" severity="secondary" [outlined]="true" (click)="onCancelMainContactDialog()"></p-button>
    <p-button label="Submit" [raised]="true" severity="secondary" (click)="onSubmitMainContact()" [loading]="fillAndSignInProgress"></p-button>
  </div>
</p-dialog>
